module.exports = __webpack_public_path__ + "img/主题动画.637456dd.png";